import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=0e9b1c7c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9b1c7c')) {
      api.createRecord('0e9b1c7c', component.options)
    } else {
      api.reload('0e9b1c7c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=0e9b1c7c&", function () {
      api.rerender('0e9b1c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m6zL7exBy029/JS/childrenage.vue"
export default component.exports